import { render } from "./dialog-confirmation.vue?vue&type=template&id=81f0f0da&scoped=true&ts=true"
import script from "./dialog-confirmation.vue?vue&type=script&lang=ts"
export * from "./dialog-confirmation.vue?vue&type=script&lang=ts"

import "./dialog-confirmation.vue?vue&type=style&index=0&id=81f0f0da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f0f0da"]])

export default __exports__